var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"type":"select2","attribute":_vm.attribute,"items":_vm.availableBranches,"options":_vm.options,"label":_vm.label,"display-field":"${item.name}","model":_vm.model}})}
var staticRenderFns = []

export { render, staticRenderFns }